export default __webpack_public_path__ + "static/media/14.7f305b82.png";